export default __webpack_public_path__ + "static/media/_DSC0530.97fc4663.JPG";